import {useContext} from 'react';

import {DomainConfigContext} from './domain-config-context';
import {DomainConfigType} from './domain-config-type';

export function useDomainConfig(): DomainConfigType {
    return useContext(DomainConfigContext);
}
